<div class="raptor-vehicle-select">

  <!-- store the NVIC value on the hidden field -->
  <div [formGroup]="form">
    <input type="hidden" [formControlName]="question.key" [id]="question.key" />
  </div>

  <div [ngSwitch]="mode">
    <div *ngSwitchCase="'rego'">

      <div class="flex flex-row flex-items-end rego-lookup">
        <div class="margin-right-medium field-rego">
          <label class="raptor-question-label">
            <span>Your car’s registration</span>
          </label>

          <mat-form-field appearance="outline" class="margin-top-xxsmall">
            <input matInput type="text" placeholder="XYZ456" [(ngModel)]="searchValues.rego">
          </mat-form-field>
        </div>

        <div class="margin-right-medium field-state">
          <label class="raptor-question-label">
            <span>In which state is your car registered?</span>
          </label>

          <div *ngIf="vehicleData && vehicleData.length">
            <div *ngFor="let field of vehicleData">
              <div *ngIf="field.key === 'state'">
                <mat-form-field appearance="outline" [class]="(question.settings && question.settings.size)" class="margin-top-xxsmall">
                  <select matNativeControl [(ngModel)]="searchValues.state">
                    <option [value]="null" class="placeholder" disabled selected hidden>Please choose</option>
                    <option *ngFor="let option of field.value" [ngValue]="option.value">{{ option.label }}</option>
                  </select>
                </mat-form-field>
              </div>
            </div>
          </div>
        </div>

        <div class="padding-top-medium flex-grow field-rego-lookup">
          <button type="button" mat-stroked-button color="secondary" (click)="lookupRego()">Find my car</button>
        </div>
      </div>

      <div class="padding-top-medium raptor-vehicle-select-manual">
        Don't know your rego?&nbsp;<a mat-button color="primary" (click)="changeMode('manual', true)">Enter the car details manually<mat-icon class="chevron_right" iconPositionEnd></mat-icon></a>
      </div>
    </div>

    <div *ngSwitchCase="'manual'">

      <div *ngIf="regoFailed && regoSearch" class="margin-bottom-medium">
        <h2 class="margin-bottom-small">Sorry we couldn’t find any results for registration {{ regoSearch }}</h2>
        <p>Please enter the car details manually below or check your registration number and<a mat-button color="primary" (click)="changeMode('rego', true)" class="margin-none">try again</a></p>
      </div>

      <div class="grid">
        <div class="cell cell-large-col-span-4" *ngFor="let field of vehicleData">
          <label *ngIf="['vehicle', 'state'].indexOf(field.key) < 0" class="raptor-question-label padding-top-medium">
            <span class="text-capitalize">{{ field.key }}</span>
          </label>

          <ng-container *ngIf="['vehicle', 'state'].indexOf(field.key) < 0">
            <mat-form-field appearance="outline" *ngIf="['make', 'variant'].indexOf(field.key) < 0" [class]="(question.settings && question.settings.size)"  class="margin-top-xxsmall">
              <select matNativeControl [name]="field.key" [(ngModel)]="searchValues[field.key]" (change)="lookupValues(field.key)" [disabled]="!field.value || field.value.length === 0">
                <option [value]="null" class="placeholder" disabled selected hidden>Please choose</option>
                <option *ngFor="let option of field.value" [ngValue]="option.value">{{ option.label }}</option>
              </select>
            </mat-form-field>
            <mat-form-field appearance="outline" *ngIf="field.key === 'make'" [class]="(question.settings && question.settings.size)"  class="margin-top-xxsmall">
              <select matNativeControl [name]="field.key" [(ngModel)]="searchValues[field.key]" (change)="lookupValues(field.key)" [disabled]="isFieldDisabled(field, question)">
                <option [value]="null" class="placeholder" disabled selected hidden>Please choose</option>
                <optgroup *ngFor="let group of field.value" [label]="group.label">
                  <option *ngFor="let option of group.value" [ngValue]="option.value">{{ option.label }}</option>
                </optgroup>
              </select>
            </mat-form-field>

            <mat-form-field appearance="outline" *ngIf="field.key === 'variant'" [class]="(question.settings && question.settings.size)"  class="margin-top-xxsmall">
              <select matNativeControl [name]="field.key" [(ngModel)]="searchValues[field.key]" (change)="lookupValues(field.key)" [disabled]="(!field.value || field.value.length === 0) || (field.value.length === 1 && field.value[0].value === '')">
                <option [value]="null" class="placeholder" disabled selected hidden>Please choose</option>
                <option *ngFor="let option of field.value" [ngValue]="option.value">{{ option.label }}</option>
              </select>
            </mat-form-field>
          </ng-container>
        </div>
      </div>

      <div class="raptor-vehicle-select-rego">
        Found your rego?&nbsp;
        <a mat-button color="primary" (click)="changeMode('rego', true)">Back to rego look up&nbsp;<mat-icon class="material-symbols-outlined undo" iconPositionEnd ></mat-icon></a>
      </div>
    </div>

    <div *ngSwitchCase="'preselected'">
      <h2 class="margin-bottom-large">Your selected car</h2>
      <div class="vehicle-preselected flex flex-row flex-items-center margin-bottom-xmedium">
        <open-svg-icon *ngIf="!iconType" name="car-yourcar" class="large margin-right-small hide-for-tiny-down"></open-svg-icon>
        <div class="lottie-player-container hide-for-tiny-down margin-right-small" *ngIf="iconType === 'json'">
          <lottie-player [src]="question.settings.icon" background="transparent" autoplay></lottie-player>
        </div>
        <div class="lottie-player-container hide-for-tiny-down" *ngIf="iconType && iconType !== 'json'">
          <open-svg-icon name="{{ question.settings.icon }}" class="large margin-right-small"></open-svg-icon>
        </div>

        <div class="padding-vertical-medium">
          <h3 class="margin-bottom-xxsmall">{{ selectedCar.label }}</h3>
          <p class="margin-bottom-none">{{ selectedCar.text }}</p>
        </div>
      </div>
      <div>
        Not your car?&nbsp;<a mat-button color="primary" (click)="changeMode('rego', true)">Look again<mat-icon class="material-symbols-outlined undo" iconPositionEnd></mat-icon></a>
      </div>
    </div>

    <div *ngFor="let field of vehicleData">
      <div *ngIf="field.key === 'vehicle'">

        <h2 class="margin-bottom-medium margin-top-medium" *ngIf="field.value.length === 1">We found your car</h2>
        <h2 class="margin-bottom-medium margin-top-medium" *ngIf="field.value.length > 1">Please select your car</h2>

        <div class="open-vehicle-select">
          <mat-radio-group [(ngModel)]="searchValues[field.key]" aria-label="Select an option">
            <mat-radio-button *ngFor="let option of field.value" [value]="option.value" class="tile-container" [ngClass]="{ 'active': option.selected === true }" (change)="selectVehicle(option, true)">
              <div class="toggle-label">
                <b class="label">{{ option.label }}</b>
                <p class="input-small margin-bottom-none">{{ option.text }}</p>
              </div>
            </mat-radio-button>
          </mat-radio-group>
        </div>

        <div class="padding-top-xsmall" *ngIf="field.value.length">
          Not your car?&nbsp;
          <a mat-button color="primary" (click)="scrollReset()">Look again<mat-icon class="material-symbols-outlined undo"></mat-icon></a>
        </div>
      </div>
    </div>

  </div>
</div>
